module.exports = __webpack_public_path__ + "static/img/NC.685e36f4.svg";